export const howItWorksSteps = [
  {
    icon: 'send',
    title: 'Você envia sua proposta',
    description:
      'Preencha o formulário com o valor que deseja oferecer, a forma de pagamento e seus dados.',
  },
  {
    icon: 'searchoutline',
    title: 'Sua proposta passa por uma triagem',
    description:
      'Faremos uma primeira análise da sua proposta para verificar se ela pode seguir no processo.',
  },
  {
    icon: 'circledollarsign',
    title: 'Você realiza a caução',
    description:
      'Se sua proposta avançar na triagem, será necessário realizar uma caução de 2% do valor da proposta. A caução demonstra que sua oferta é firme e permite que ela siga para análise do Comitê do Vendedor.',
  },
  {
    icon: 'gavel',
    title: 'O Vendedor analisa sua proposta',
    description:
      'A proposta poderá ser aceita, recusada ou receber uma contraproposta. Enquanto isso, o imóvel continua disponível para comercialização.',
  },
  {
    icon: 'handshake',
    title: 'Se aprovada, seguimos com você',
    description:
      'Nossa equipe orientará você sobre os próximos passos para formalização da compra do imóvel.',
  },
]

export const faqItems = [
  {
    question: 'Por que preciso realizar uma caução?',
    answer:
      'A caução é uma forma de demonstrar que a proposta é firme e que existe interesse efetivo na aquisição do imóvel. Ela é exigida somente após a proposta passar pela triagem inicial e antes de ser encaminhada para análise efetiva do Comitê do Vendedor.',
  },
  {
    question: 'E se o Vendedor não aceitar minha proposta?',
    answer:
      'Caso o Vendedor não aceite a proposta, o valor da caução é devolvido e o imóvel permanece disponível para novas negociações.',
  },
  {
    question: 'E se eu desistir da proposta?',
    answer:
      'Você pode desistir da proposta antes da aceitação do Vendedor. As condições de devolução da caução dependem do momento da desistência.',
  },
  {
    question: 'E se o Vendedor fizer uma contraproposta?',
    answer:
      'Você será notificado e poderá aceitar, recusar ou enviar uma nova proposta com condições diferentes.',
  },
  {
    question: 'Quem é responsável pela caução e pela devolução do valor?',
    answer:
      'A Resale é responsável por intermediar o processo de caução e sua devolução, conforme o andamento da negociação.',
  },
  {
    question:
      'O envio da proposta e a realização da caução garantem que minha proposta será aceita?',
    answer:
      'Não. O envio da proposta ou a realização da caução não representam aceite, reserva ou compromisso de venda do imóvel.',
  },
  {
    question:
      'Se minha proposta for aprovada comercialmente, significa que o imóvel já é meu?',
    answer:
      'Não. A aprovação comercial é uma das etapas do processo. A aquisição só se concretiza após a formalização completa da compra.',
  },
  {
    question: 'Quanto tempo leva para minha proposta ser analisada?',
    answer:
      'O prazo pode variar conforme o Vendedor e a complexidade da negociação. Nossa equipe manterá você informado sobre o andamento.',
  },
]

export const paymentMethods = [
  {
    value: 'vista',
    icon: 'banknote',
    label: 'À vista',
    description: 'Pagamento integral conforme condições da operação.',
  },
  {
    value: 'financiamento',
    icon: 'landmark',
    label: 'Financiamento bancário',
    description: 'Compra utilizando financiamento de instituição financeira.',
  },
  {
    value: 'parcelamento',
    icon: 'creditcard',
    label: 'Parcelamento',
    description:
      'Pagamento parcelado conforme condições negociadas com o Vendedor.',
  },
]

export const personTypes = [
  { value: 'pf', label: 'PF - Pessoa Física' },
  { value: 'pj', label: 'PJ - Pessoa Jurídica' },
]
